import React, { useEffect } from 'react';

const BodyWrapper = ({ children }) => {
  return (
    <div className={`relative min-h-screen bg-slate-50`}>
      <main className="w-full min-h-screen">{children}</main>
    </div>
  );
};

export default BodyWrapper;
